import * as bootstrap from 'bootstrap';

import debounce from '../utils/debounce';
import $ from 'jquery'

// On ready Pure JS
document.addEventListener('DOMContentLoaded', () => {

	const forms = document.querySelectorAll('.needs-validation');

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms)
		.forEach(function (form) {
			$(form).children().on('change keyup', debounce(() => {
				$(form).find(':submit').attr('disabled', !form.checkValidity());
			}));

			form.addEventListener('submit', function (event) {
				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated');
			}, false)
		});


	// Prevent forms with that require confirmation from submitting
	$('form.requires-confirmation').one('submit', (e) => {
		e.preventDefault();

		const {currentTarget} = e;
		const name = $(currentTarget).data('name');

		// Confirm Modal
		const confirmModalEl = document.getElementById('confirmDeleteModal');
		const confirmModal = new bootstrap.Modal(confirmModalEl);

		$(confirmModalEl).find('.name').html(name);
		$(confirmModalEl).find('.btn.delete').on('click', () => {
			$(currentTarget).submit();
		});

		confirmModal.show();
	});

	$('#search').on('blur keyup', (e) => {
		if (e.keyCode === 13) {
			const {currentTarget} = e;
			const search = $(currentTarget).val();

			const url = $(currentTarget).data('url');
			window.location = `${url}?s=${search}`;
		}
	});
});